import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import Icon from '../../common/Icons';
import { ADMIN_COPY } from '../adminCopy';
import { ADMIN_PATHS } from '../adminPaths';
import './AdminReportsDomainNav.css';

const DOMAINS = [
  {
    id: 'reception',
    to: ADMIN_PATHS.REPORTS_RECEPTION,
    matchPrefix: ADMIN_PATHS.REPORTS_RECEPTION,
    ...ADMIN_COPY.NAV.reportsReception
  },
  {
    id: 'infirmerie',
    to: ADMIN_PATHS.REPORTS_INFIRMERIE,
    matchPrefix: ADMIN_PATHS.REPORTS_INFIRMERIE,
    ...ADMIN_COPY.NAV.reportsNursing
  },
  {
    id: 'clinique',
    to: ADMIN_PATHS.REPORTS_CLINIQUE,
    matchPrefix: ADMIN_PATHS.REPORTS_CLINIQUE,
    ...ADMIN_COPY.NAV.reportsClinical
  },
  {
    id: 'pharmacie',
    to: ADMIN_PATHS.REPORTS_PHARMACIE,
    matchPrefix: ADMIN_PATHS.REPORTS_PHARMACIE,
    ...ADMIN_COPY.NAV.reportsPharmacy
  }
];

export default function AdminReportsDomainNav() {
  const { pathname } = useLocation();

  return (
    <nav className="adm-reports-domains" aria-label="Domaines de rapports">
      {DOMAINS.map((domain) => {
        const active =
          pathname === domain.matchPrefix || pathname.startsWith(`${domain.matchPrefix}/`);
        return (
          <NavLink
            key={domain.id}
            to={domain.to}
            className={`adm-reports-domains__link${active ? ' is-active' : ''}`}
            end={false}
            title={domain.hint}
          >
            <Icon name={domain.icon} size={15} aria-hidden />
            <span>{domain.label}</span>
          </NavLink>
        );
      })}
    </nav>
  );
}
